import ConfirmPhoneForm from "./ConfirmPhoneFromsClass";

export default class AuthFormsSubmit extends ConfirmPhoneForm {
    constructor() {
        super('.forms_group_submitting');
    }

    /**
     *
     * @param $form
     */
    formValidator($form) {
        let $this = this,
            $inF = $form.validate({
                highlight: function (element) {
                    $(element).parent().addClass("error").removeClass("valid");
                },
                unhighlight: function (element) {
                    $(element).parent().removeClass("error").addClass("valid");
                },
                submitHandler: function (form) {
                    //Check actions
                    let action = $(form).attr('action'),
                        dataTo = $(form).attr('data-to'),
                        formData = new FormData($(form)[0]);

                    $(form).find('button[type="submit"]').prop('disabled', true);
                    $($this.formsGroup).find(' > form .btn-area a.to_form').addClass('disabled');

                    $.ajax({
                        type: "POST",
                        url: action,
                        processData: false,
                        contentType: false,
                        data: formData,
                        dataType: "json"
                    })
                    .then(function (resp) {
                        if (!resp.success) {
                            $this.showFormError($form, resp.message);
                            return;
                        }

                        $this.hideFormError($form);

                        //Close & reset other auth form group
                        let $thisGroupFrom = $(form).closest('.forms_group_submitting');
                        $('.forms_group_submitting').each(function () {
                            if($(this)[0] !== $thisGroupFrom[0]) {
                                let $thisEach = $(this);
                                $(this).find('> form:not(:first-child)').animate({opacity: 0}, 200, function() {
                                    $thisEach.find('> form:not(:first-child)').hide();

                                    $thisEach.find('> form:first-child').show();
                                    $thisEach.find('> form:first-child').animate({opacity: 1}, 200, function () {
                                    });
                                });

                                //Reset forms
                                $(this).find('> form').each(function () {
                                    $this.resetThisForm($(this));
                                })
                            }
                        });

                        //Send sms and show code form
                        if(resp.data['auth_step_1']) {
                            $(form).animate({opacity: 0}, 200, function() {
                                //Hide from
                                $(form).hide();

                                //Initial sms timer
                                if($(dataTo).attr('data-timer')) {
                                    $this.timerSendSms($(dataTo));

                                    $(dataTo).on('click', '.send_sms_again a', function (e) {
                                        e.preventDefault();
                                        if($(this).hasClass('active')) {
                                            $this.timerSendSms($(dataTo));
                                            if($(dataTo).attr('data-parent')) {
                                                //TODO: need reset form?
                                                $($(dataTo).attr('data-parent')).trigger('submit');

                                                //Hide general errors
                                                $(this).closest('form').find('.error-general').hide();
                                            }
                                        }
                                    });

                                    //Set phone number
                                    let phone = $(form).find('input[type="tel"]').val();
                                    $(dataTo).find('.header_info .number').html(phone);
                                    $(dataTo).find('input[name="phone_number"]').val(phone);
                                }

                                //Show next block
                                $(dataTo).show();
                                $(dataTo).animate({opacity: 1}, 200);

                                //Set focus to input for code
                                $(dataTo).find('input[name="sms_code"]').focus();
                            });
                        }

                        //Success auth|register
                        if(resp.data['auth_step_2']) {
                            //location.reload();
                            location.href = resp.data['url']
                        }

                    })
                    .fail(function (xhr) {
                        console.log(xhr);
                        $this.ajaxErrorForm($inF, xhr);
                    })
                    .always(function () {
                        $(form).find('button[type="submit"]').prop('disabled', false);
                        $($this.formsGroup).find('> form .btn-area a.to_form').removeClass('disabled');
                    });
                }
            });

        this.initForms.push($inF);
    }
}
